module.exports = __webpack_public_path__ + "f4613d1835df2ebd32ca23c85d93f04a.pdf";